<template>
    <BaseModal ref="baseModalRef" v-bind="childProps">

        <template v-slot:body>
            <div class="search-wrap">
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-3">
                        <ElLabel name="회사명">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.cmp_nm" @inputKeyupEnter="getCpList"/>
                            </template>
                        </ElLabel>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                        <ElLabel name="사업부명">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.cmp_dvsn_nm" @inputKeyupEnter="getCpList"/>
                            </template>
                        </ElLabel>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                            <ElLabel name="사업자등록번호">
                                <template #end="{id}">
                                    <ElInput :id="id"
                                    ref="businessNoRef"
                                    @update:modelValue="r=>bizNoFormat(r)"
                                    @inputKeyupEnter="getCpList"/>
                                </template>
                            </ElLabel>
                        </div>
                    </div>                    
                </div>
            </div>
            <div class="search-detail-wrap"></div>
    
            <div class="text-end py-2">
                <ElButton type="search" @buttonClick="getCpList()">검색</ElButton>
            </div>
    
            <div class="table-responsive table-list">
                <DataTable  
                    v-model:selection="state.selectedRow" 
                    :value="state.gridRowData"   
                    selectionMode="single"
                    dataKey="cp_seq"
                    paginator 
                    :rows="20" 
                    :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
                    @row-dblclick="rowDbClick"
                >
                    <Column 
                        v-for="company of state.gridColumn" 
                        :key="company" 
                        :field="company.field"
                        :header="company.headerName"
                        sortable
                        :class="company.class"
                    />
                </DataTable>
            </div>

        </template>
    </BaseModal>

</template>

<script setup>
import { reactive,ref, onMounted } from 'vue';
import BaseModal from '@/components/common/modal/BaseModal.vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { compList } from '@/api/comp';
import common from '@/js/common';
const emits = defineEmits(['return'])
const baseModalRef = ref()
const businessNoRef = ref()
onMounted(async()=> {
    await getCpList();
})

const state = reactive({
    gridColumn: [
        { headerName: "회사명", field: "cmp_nm",class : 'lg-col'},
        { headerName: "사업부명", field: "cmp_dvsn_nm",class : 'lg-col'},
        { headerName: "사업자등록번호", field: "business_no",class : 'mid-col'},
        { headerName: "대표자", field: "ceo_nm",class : 'sml-col'},
        { headerName: "등록일시", field: "fmt_reg_dt",class : 'mid-col'},
    ],
    gridRowData :[],
    selectedRow :null,
  searchParams : {
    cmp_nm: '',
    cmp_dvsn_nm : '',
    business_no : '',
    page_count : 1,
    unit_count : 100000,
  },
})

const childProps = ref({
    modalId : 'lead',
    modalNm : '사업부명 조회',
    size:'xl',
    btnList : [
        {name : '선택' , classNm : 'modelFooterConfirm', function : selectCp}
    ]
})


async function getCpList () {
    let params = state.searchParams

    try {
        setIsLoading(true)
        const res = await compList(params)
        state.gridRowData = res.rtn;
    } catch (err) {
        console.error('api error',err)
        alert('회사정보 조회 실패')
    } finally {
        setIsLoading(false)
    }
}

function selectCp(){
    let company = state.selectedRow
    if(company){
        emits('return',company)
    }else{
        alert('선택된 행이 없습니다.')
    }
    closeModal()

}


function openModal(){
  baseModalRef.value.openModal()
}

function closeModal(){
  baseModalRef.value.closeModal()
}

function rowDbClick(row){
    emits('return',row.data)
    closeModal()
}

//사업자번호 형식 체크
const bizNoFormat = (no) => {
    state.searchParams.business_no = common.bizNoFormat(no);
    businessNoRef.value.input.value = state.searchParams.business_no
};
defineExpose({
    openModal
})

</script>